var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BE24CB35-80DC-4BC6-A050-407EAB3E0D4D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sticker-Sheet",
    transform: "translate(-742.000000, -836.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ascending-Copy-56",
    transform: "translate(742.000000, 836.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 2 26 2 26 26 2 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hover-Style"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "State"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.881559,14.88125 C20.9201111,14.6 20.9393872,14.309375 20.9393872,14 C20.9393872,13.7 20.9201111,13.4 20.8719209,13.11875 L22.8284426,11.6375 C23.0019273,11.50625 23.0501175,11.253125 22.9440991,11.065625 L21.0935958,7.953125 C20.9779394,7.746875 20.7369884,7.68125 20.5249516,7.746875 L18.2214605,8.646875 C17.7395587,8.290625 17.2287427,7.990625 16.6600984,7.765625 L16.3131291,5.384375 C16.2745769,5.159375 16.0818162,5 15.8505033,5 L12.1494967,5 C11.9181838,5 11.7350611,5.159375 11.696509,5.384375 L11.3495396,7.765625 C10.7808954,7.990625 10.2604413,8.3 9.78817749,8.646875 L7.48468646,7.746875 C7.27264963,7.671875 7.03169868,7.746875 6.91604223,7.953125 L5.07517701,11.065625 C4.95952056,11.2625 4.99807271,11.50625 5.19083347,11.6375 L7.14735514,13.11875 C7.09916495,13.4 7.0606128,13.709375 7.0606128,14 C7.0606128,14.290625 7.07988887,14.6 7.12807906,14.88125 L5.17155739,16.3625 C4.99807271,16.49375 4.94988252,16.746875 5.05590094,16.934375 L6.90640419,20.046875 C7.02206065,20.253125 7.26301159,20.31875 7.47504842,20.253125 L9.77853945,19.353125 C10.2604413,19.709375 10.7712573,20.009375 11.3399016,20.234375 L11.6868709,22.615625 C11.7350611,22.840625 11.9181838,23 12.1494967,23 L15.8505033,23 C16.0818162,23 16.2745769,22.840625 16.303491,22.615625 L16.6504604,20.234375 C17.2191046,20.009375 17.7395587,19.709375 18.2118225,19.353125 L20.5153135,20.253125 C20.7273504,20.328125 20.9683013,20.253125 21.0839578,20.046875 L22.934461,16.934375 C23.0501175,16.728125 23.0019273,16.49375 22.8188046,16.3625 L20.881559,14.88125 Z M14,17.375 C12.0916685,17.375 10.5303064,15.85625 10.5303064,14 C10.5303064,12.14375 12.0916685,10.625 14,10.625 C15.9083315,10.625 17.4696936,12.14375 17.4696936,14 C17.4696936,15.85625 15.9083315,17.375 14,17.375 Z",
    id: "Icon-Color",
    fill: "#50566E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.038f6a50d4601f2fbc0559e80c23edfe.svg";
export { ForwardRef as ReactComponent };